import React from "react";
import Seo from "@/utils/seo";
import Section from "@/components/ui/section";
import Image from "next/image";
export default function AboutUs() {
  return (
    <>
      <Seo metaTitle={`About Us | Rose Bowl`} slug={`about-us`} />
      <Section>
        <div className="flex lg:flex-row flex-col-reverse items-center lg:gap-20 gap-6 md:mt-[120px] mt-[90px]">
          <div className="flex flex-col w-full gap-3">
            <h1>About Us</h1>
            <p>
              At Rose Bowl, the essence of craftsmanship and artistry is at the
              heart of every creation. Each product is a reflection of the
              exceptional skill and creativity of artisans who bring a unique
              fusion of futuristic vision and imaginative design to life. This
              fusion results in pieces where art meets elegance, delivering a
              sense of refined sophistication that stands the test of time.
            </p>
            <p>
              Luxury is redefined through creations that exude not only timeless
              elegance but also unparalleled creativity. Every product is
              thoughtfully crafted, blending forward-thinking design with
              meticulous attention to detail, ensuring each piece is distinctive
              and enduring. These are not just products but works of art, meant
              to be cherished for generations and appreciated for their
              uniqueness and craftsmanship. At Rose Bowl, the commitment lies in
              offering creations that captivate and leave a lasting impression.
            </p>
          </div>
          <div className="relative lg:w-[400px] w-full md:h-[350px] h-[250px] shrink-0 rounded-2xl overflow-hidden">
            <Image
              src="/images/about-us-banner.webp"
              fill
              alt="about us"
              className="object-cover object-center w-full h-full"
              sizes="(max-width: 768px) 400px, (max-width: 1200px) 400px, 400px"
            />
          </div>
        </div>
      </Section>
    </>
  );
}
